<template lang="pug">
    div
        p(v-for="(item, index) in listData", :key="item" v-if="index < maxShow")
            | {{ item }}
        Button(
            size="small"
            v-if="listData.length > maxShow"
            @click="showResult = !showResult"
            icon="ios-eye"
        )
            | view
        Modal(:title="title" v-model="showResult")
            .poptipExplain
                p(v-for="data in listData") {{ data }}
</template>
<script>
export default {
    name: "StringList",
    props: ["listData", "maxShow", "title", "width"],
    components: {},
    watch: {},
    created() {},
    data() {
        return {
            showResult: false
        };
    },
    methods: {},
    mounted() {},
    computed: {}
};
</script>
<style scoped>
.poptipExplain {
    overflow: auto;
    white-space: normal;
    word-break: break-all;
    line-height: 25px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/StringList.vue